/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DateRange } from './DateRange';
import {
    DateRangeFromJSON,
    DateRangeFromJSONTyped,
    DateRangeToJSON,
    DateRangeToJSONTyped,
} from './DateRange';
import type { Int32RangeFilter } from './Int32RangeFilter';
import {
    Int32RangeFilterFromJSON,
    Int32RangeFilterFromJSONTyped,
    Int32RangeFilterToJSON,
    Int32RangeFilterToJSONTyped,
} from './Int32RangeFilter';
import type { BoundingBox } from './BoundingBox';
import {
    BoundingBoxFromJSON,
    BoundingBoxFromJSONTyped,
    BoundingBoxToJSON,
    BoundingBoxToJSONTyped,
} from './BoundingBox';
import type { DecimalRangeFilter } from './DecimalRangeFilter';
import {
    DecimalRangeFilterFromJSON,
    DecimalRangeFilterFromJSONTyped,
    DecimalRangeFilterToJSON,
    DecimalRangeFilterToJSONTyped,
} from './DecimalRangeFilter';

/**
 * 
 * @export
 * @interface FilterRequestDto
 */
export interface FilterRequestDto {
    /**
     * 
     * @type {number}
     * @memberof FilterRequestDto
     */
    year?: number | null;
    /**
     * 
     * @type {DateRange}
     * @memberof FilterRequestDto
     */
    dateRange?: DateRange;
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterRequestDto
     */
    categoryIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterRequestDto
     */
    categoryNames?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterRequestDto
     */
    businessUnitIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterRequestDto
     */
    companyIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterRequestDto
     */
    labelIds?: Array<string> | null;
    /**
     * 
     * @type {DecimalRangeFilter}
     * @memberof FilterRequestDto
     */
    orderAmountRange?: DecimalRangeFilter;
    /**
     * 
     * @type {Int32RangeFilter}
     * @memberof FilterRequestDto
     */
    orderCountRange?: Int32RangeFilter;
    /**
     * 
     * @type {string}
     * @memberof FilterRequestDto
     */
    orderCountTier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FilterRequestDto
     */
    revenueTier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FilterRequestDto
     */
    location?: string | null;
    /**
     * 
     * @type {BoundingBox}
     * @memberof FilterRequestDto
     */
    boundingBox?: BoundingBox;
    /**
     * 
     * @type {Date}
     * @memberof FilterRequestDto
     */
    readonly effectiveStartDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof FilterRequestDto
     */
    readonly effectiveEndDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof FilterRequestDto
     */
    readonly hasBoundingBox?: boolean;
}

/**
 * Check if a given object implements the FilterRequestDto interface.
 */
export function instanceOfFilterRequestDto(value: object): value is FilterRequestDto {
    return true;
}

export function FilterRequestDtoFromJSON(json: any): FilterRequestDto {
    return FilterRequestDtoFromJSONTyped(json, false);
}

export function FilterRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'year': json['year'] == null ? undefined : json['year'],
        'dateRange': json['dateRange'] == null ? undefined : DateRangeFromJSON(json['dateRange']),
        'categoryIds': json['categoryIds'] == null ? undefined : json['categoryIds'],
        'categoryNames': json['categoryNames'] == null ? undefined : json['categoryNames'],
        'businessUnitIds': json['businessUnitIds'] == null ? undefined : json['businessUnitIds'],
        'companyIds': json['companyIds'] == null ? undefined : json['companyIds'],
        'labelIds': json['labelIds'] == null ? undefined : json['labelIds'],
        'orderAmountRange': json['orderAmountRange'] == null ? undefined : DecimalRangeFilterFromJSON(json['orderAmountRange']),
        'orderCountRange': json['orderCountRange'] == null ? undefined : Int32RangeFilterFromJSON(json['orderCountRange']),
        'orderCountTier': json['orderCountTier'] == null ? undefined : json['orderCountTier'],
        'revenueTier': json['revenueTier'] == null ? undefined : json['revenueTier'],
        'location': json['location'] == null ? undefined : json['location'],
        'boundingBox': json['boundingBox'] == null ? undefined : BoundingBoxFromJSON(json['boundingBox']),
        'effectiveStartDate': json['effectiveStartDate'] == null ? undefined : (new Date(json['effectiveStartDate'])),
        'effectiveEndDate': json['effectiveEndDate'] == null ? undefined : (new Date(json['effectiveEndDate'])),
        'hasBoundingBox': json['hasBoundingBox'] == null ? undefined : json['hasBoundingBox'],
    };
}

export function FilterRequestDtoToJSON(json: any): FilterRequestDto {
    return FilterRequestDtoToJSONTyped(json, false);
}

export function FilterRequestDtoToJSONTyped(value?: Omit<FilterRequestDto, 'effectiveStartDate'|'effectiveEndDate'|'hasBoundingBox'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'year': value['year'],
        'dateRange': DateRangeToJSON(value['dateRange']),
        'categoryIds': value['categoryIds'],
        'categoryNames': value['categoryNames'],
        'businessUnitIds': value['businessUnitIds'],
        'companyIds': value['companyIds'],
        'labelIds': value['labelIds'],
        'orderAmountRange': DecimalRangeFilterToJSON(value['orderAmountRange']),
        'orderCountRange': Int32RangeFilterToJSON(value['orderCountRange']),
        'orderCountTier': value['orderCountTier'],
        'revenueTier': value['revenueTier'],
        'location': value['location'],
        'boundingBox': BoundingBoxToJSON(value['boundingBox']),
    };
}

